export enum ChainId {
  MAINNET = 2000,
  TESTNET = 2001
}